module.exports = __webpack_public_path__ + "static/federation_logo1-9466a6c077173ee547ed113702cad5d4.png";